/*
 * Copyright (c) 2019 Signum+ Software & Facility GmbH
 * Author: jahn@signum-plus.at
 */

export class ServiceProvider {
  private static serviceMap = new Map<string, any>();

  static registerService<T>(key: string, service: T) {
    ServiceProvider.serviceMap.set(key, service);
  }

  static resolveService<T>(key: string): T {
    const service: T | undefined = ServiceProvider.serviceMap.get(key);
    if (!service) {
      throw new Error(`Service '${key}' was not registered`);
    }
    return service;
  }

}
